import React from 'react';
import { MLink } from './ManualLink';

function TspContent1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        서비스의 주요 기능 바로가기, 실증장비 현황, 공지사항 등 핵심 정보를 한눈에 확인할 수 있는 홈 화면입니다.
      </p>
      <ul className="menual-contents">
        <li>
          <p className="txt semibold">① GNB (상단 메뉴)</p>
          <ul className="menual-list">
            {/* <li>AI 실증지원, 실증장비 예약, 이용지원, 마이페이지 메뉴를 이용할 수 있습니다.</li> */}
            <li>[돋보기] 클릭 시 통합검색 사이트로 이동합니다.</li>
            <li>[햄버거] 클릭 시 팝업 사이트맵이 노출됩니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">② 메인 배너</p>
          <ul className="menual-list">
            <li>최대 5개 자동 롤링, [&lt;] [II] [&gt;] 클릭 시 이전/정지/다음 이동</li>
            <li>배너 클릭 시 해당 상세 페이지로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">③ 공지사항</p>
          <ul className="menual-list">
            <li>최대 4개 노출, 고정 공지 1개 [중요] 아이콘 표시</li>
            <li>게시글 클릭 시 해당 상세 페이지로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">④ 퀵메뉴</p>
          <ul className="menual-list">
            <li>실증지원센터 소개, 사용안내, 장비신청, 장비사용관리, 1:1문의내역</li>
            <li>각 항목 클릭 시 해당 메뉴로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">⑤ 실증장비 현황</p>
          <ul className="menual-list">
            <li>자동차 / 에너지 / 헬스케어 분야별 보유 장비 대수를 확인할 수 있습니다.</li>
            <li>각 분야 클릭 시 장비신청 목록으로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">⑥ 실증장비 목록</p>
          <ul className="menual-list">
            <li>전체 / 헬스케어 / 에너지 / 자동차 탭 선택 시 해당 분야 목록으로 변경됩니다.</li>
            <li>최대 12개 노출, [&lt;] [&gt;] 클릭 시 롤링</li>
            <li>장비 카드 클릭 시 상세 페이지로 이동합니다.</li>
            <li>[+ 더보기] 클릭 시 장비신청 메뉴로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">⑦ 실증센터</p>
          <ul className="menual-list">
            <li>AI 자동차 / AI 에너지 / AI 헬스케어 실증센터 위치를 지도에서 확인할 수 있습니다.</li>
            <li>위치 아이콘·타이틀 클릭 시 해당 실증센터 상세 정보가 표시됩니다.</li>
            <li>[상세보기] 클릭 시 해당 실증장비 메뉴로 이동합니다.</li>
            <li>[지도보기] 클릭 시 길 안내 지도로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">⑧ 유관사이트</p>
          <ul className="menual-list">
            <li>인공지능산업융합사업단, 광주광역시, 정보통신산업진흥원, 과학기술정보통신부 등 자동 롤링</li>
            <li>사이트명 클릭 시 해당 사이트로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">⑨ 푸터</p>
          <ul className="menual-list">
            <li>개인정보처리방침, 이용약관, 자주묻는질문, 사용자매뉴얼 클릭 시 해당 페이지로 이동합니다.</li>
            <li>SNS 아이콘(인스타그램, 유튜브, 페이스북) 클릭 시 해당 사이트로 이동합니다.</li>
            <li>주소 : 광주광역시 북구 첨단과기로 176번길 11 3층 / 대표번호 : 062-610-3900 / 장애문의 : 062-610-3919</li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

export function TspContent2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        회원가입 후 로그인하여 서비스를 이용할 수 있습니다. 아이디 또는 비밀번호를 잊은 경우 계정찾기를 통해 확인할 수 있습니다.
      </p>
    </div>
  );
}

export function TspContent2_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 로그인 &gt; <MLink to="/signup">회원가입</MLink></p>
      <p className="txt">회원가입은 약관동의 → 본인인증 → 정보입력 → 가입완료 순서로 진행됩니다.</p>
      <p className="txt">① 약관동의</p>
      <ul className="menual-list">
        <li>이용약관 (필수), 개인정보 수집·활용 동의 (필수), 개인정보 수집·활용 동의 (선택) 항목을 확인 후 동의하세요.</li>
        <li>전체동의 선택 시 하위 항목이 일괄 선택됩니다.</li>
      </ul>
      <p className="txt">② 본인인증</p>
      <ul className="menual-list">
        <li>[휴대폰 본인인증] 클릭 시 PASS 인증 팝업이 실행됩니다.</li>
        <li>PASS 앱 인증 절차를 완료하면 본인인증이 처리됩니다.</li>
      </ul>
      <p className="txt">③ 정보입력</p>
      <ul className="menual-list">
        <li>아이디 : 영문/숫자 조합 4~12자 입력 후 [중복확인] 클릭하세요.</li>
        <li>비밀번호 : 영문, 숫자, 특수문자 포함 8~16자리 입력하세요.</li>
        <li>생년월일, 휴대폰번호, 이메일, 소속 : 직접 입력하세요.</li>
        <li>사업자등록번호 : 숫자만 입력 후 [조회] 클릭하세요.</li>
      </ul>
      <p className="txt">④ 가입완료</p>
      <ul className="menual-list">
        <li>[홈으로 이동] 클릭 시 메인 화면으로 이동합니다.</li>
        <li>[로그인] 클릭 시 로그인 화면으로 이동합니다.</li>
      </ul>
    </div>
  );
}

export function TspContent2_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 <MLink to="/tsp/signin">로그인</MLink></p>
      <ul className="menual-list">
        <li>아이디와 비밀번호를 입력 후 [로그인] 클릭하세요.</li>
        <li>SNS 계정(카카오, 네이버, 구글)으로 간편 로그인할 수 있습니다.</li>
      </ul>
    </div>
  );
}

export function TspContent2_3() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 로그인 &gt; <MLink to="/signin/idtrouver">아이디 찾기</MLink></p>
      <ul className="menual-list">
        <li>인증 방식을 선택하세요. : 휴대폰번호 / 이메일</li>
        <li>이름을 입력하세요.</li>
        <li>선택한 인증 방식에 따라 휴대폰번호 또는 이메일을 입력 후 [인증번호 발송] 클릭하세요.</li>
        <li>수신한 인증번호를 입력 후 [인증] 클릭 시 가입된 아이디가 표시됩니다.</li>
        <li>[로그인] 클릭 시 로그인 페이지로 이동합니다.</li>
        <li>[비밀번호 찾기] 클릭 시 비밀번호 찾기 페이지로 이동합니다.</li>
      </ul>
    </div>
  );
}

export function TspContent2_4() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 로그인 &gt; <MLink to="/signin/factor">비밀번호 찾기</MLink></p>
      <p className="txt">① 본인 확인</p>
      <ul className="menual-list">
        <li>가입 시 등록한 아이디를 입력하세요.</li>
        <li>인증 방식을 선택하세요. : 휴대폰번호 / 이메일</li>
        <li>선택한 인증 방식에 따라 휴대폰번호 또는 이메일을 입력 후 [인증번호 발송] 클릭하세요.</li>
        <li>수신한 인증번호를 입력 후 [인증] 클릭 시 인증이 완료됩니다.</li>
      </ul>
      <p className="txt">② 비밀번호 재설정</p>
      <ul className="menual-list">
        <li>새 비밀번호 : 영문, 숫자, 특수문자 포함 8~16자리 입력하세요.</li>
        <li>새 비밀번호 확인을 입력하세요.</li>
        <li>[변경하기] 클릭 시 비밀번호 재설정이 완료됩니다.</li>
      </ul>
    </div>
  );
}

export function TspContent3() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        회원정보 변경, 기업인증, SNS 로그인 연동, 회원탈퇴를 마이페이지에서 관리할 수 있습니다.
      </p>
    </div>
  );
}

export function TspContent3_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 마이페이지 &gt; <MLink to="/Mypage/MemberInfoMmt/MemberInfoMdf">회원정보변경</MLink></p>
      <p className="txt">회원정보 수정을 위해 현재 비밀번호를 입력 후 [확인] 클릭하세요.</p>
      <p className="txt">① 기본정보</p>
      <ul className="menual-list">
        <li>회원유형, 아이디 : 자동 입력 (수정 불가)</li>
        <li>현재 비밀번호, 새 비밀번호, 새 비밀번호 확인을 입력하세요.</li>
        <li>새 비밀번호 : 영문, 숫자, 특수문자 포함 8~16자리</li>
        <li>새 비밀번호 필드가 비어 있으면 비밀번호는 변경되지 않습니다.</li>
        <li>이름, 생년월일 : 자동 입력 (수정 불가)</li>
        <li>휴대폰번호 : 변경 시 [인증] 클릭 후 본인인증을 완료하세요.</li>
        <li>소속 : 직접 입력하세요.</li>
        <li>사업자등록번호 : 숫자만 입력 후 [조회] 클릭하세요.</li>
      </ul>
      <p className="txt">② 버튼</p>
      <ul className="menual-list">
        <li>[이전] 클릭 시 이전 페이지로 이동합니다.</li>
        <li>[저장] 클릭 시 입력한 정보가 저장됩니다.</li>
      </ul>
    </div>
  );
}

export function TspContent3_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 마이페이지 &gt; <MLink to="/Mypage/MemberInfoMmt/MemberInfoMdf">회원정보변경</MLink> &gt; 회원정보변경 상세</p>
      <ul className="menual-list">
        <li>기본정보 영역의 [기업인증] 클릭 시 공동인증서 팝업이 실행됩니다.</li>
        <li>공동인증서 인증 완료 시 회원유형이 '개인' → '개인(기업인증 완료)'로 변경됩니다.</li>
      </ul>
    </div>
  );
}

export function TspContent3_3() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 마이페이지 &gt; <MLink to="/Mypage/MemberInfoMmt/MemberInfoMdf">회원정보변경</MLink> &gt; 회원정보변경 상세</p>
      <ul className="menual-list">
        <li>SNS 연동은 회원정보변경 상세 페이지 내 SNS 연동 영역에서 관리합니다.</li>
        <li>연동 가능 계정 : 카카오 / 네이버 / 구글</li>
        <li>연동 후 해당 SNS 계정으로 간편 로그인할 수 있습니다.</li>
      </ul>
    </div>
  );
}

export function TspContent3_4() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 마이페이지 &gt; <MLink to="/Mypage/MemberInfoMmt/MemberInfoMdf">회원정보변경</MLink> &gt; 회원정보변경 상세 &gt; [회원탈퇴]</p>
      <ul className="menual-list">
        <li>탈퇴 전 유의사항을 반드시 확인하세요.</li>
        <li>불편사항 문의는 <MLink to="/tsp/About/Inquiry">1:1문의</MLink> 페이지를 이용하세요.</li>
        <li>유의사항 확인 후 '위 유의사항을 모두 확인하였으며, 동의합니다.' 체크박스를 선택하세요.</li>
        <li>[취소] 클릭 시 이전 페이지로 이동합니다.</li>
        <li>[회원탈퇴] 클릭 시 탈퇴 가능 여부를 확인 후 처리됩니다.</li>
      </ul>
      <p className="txt">탈퇴 가능</p>
      <ul className="menual-list">
        <li>'회원탈퇴가 완료되었습니다.' 팝업 노출 → [확인] 클릭 시 메인 화면으로 이동합니다.</li>
      </ul>
      <p className="txt">탈퇴 불가</p>
      <ul className="menual-list">
        <li>'회원탈퇴가 제한되어 있습니다.' 팝업 노출</li>
        <li>[확인] 클릭 시 팝업이 닫힙니다.</li>
        <li>[미해결 건 확인하기] 클릭 시 마이페이지 &gt; 대시보드로 이동합니다.</li>
      </ul>
    </div>
  );
}

/* ── 4. 실증장비 예약하기 ── */

function TspContent4() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        실증장비 예약은 장비 검색 → 견적요청(선택) → 사용 신청 → 승인 → 장비 사용 → 사용료 납부 순서로 진행됩니다.
      </p>
    </div>
  );
}

function TspContent4_1_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 실증장비 예약 &gt; <MLink to="/tsp/Apply/Equipment">장비신청</MLink></p>
      <ul className="menual-list">
        <li>검색 : 제품명, 카테고리, 사용료, 키워드 기준 검색 가능</li>
        <li>카테고리 필터 : 대분류·중분류 선택 가능</li>
        <li>키워드 필터 : 등록된 키워드 선택 (최대 5개)</li>
        <li>체크박스 필터 : 예약가능 / 반출 가능 / 무료 (다중 선택 가능)</li>
        <li>선택한 조건은 태그 형태로 표시되며, [X] 클릭 시 삭제 가능</li>
        <li>목록은 최대 10개씩 노출되며, 카드 클릭 시 상세 페이지로 이동합니다.</li>
      </ul>
    </div>
  );
}

function TspContent4_1_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 실증장비 예약 &gt; <MLink to="/tsp/Apply/Equipment">장비신청</MLink> &gt; 장비신청 상세</p>
      <p className="txt">① 기본정보 / 장비 사양</p>
      <ul className="menual-list">
        <li>장비 이미지는 최대 5개 노출되며, [&lt;] [&gt;] 클릭 시 이전/다음 이동합니다.</li>
        <li>카테고리, 키워드, 반출여부, 대여료, 1일 가용시간을 확인할 수 있습니다.</li>
        <li>모델명, 제조사, 주요기능, 설치장소를 확인할 수 있습니다.</li>
      </ul>
      <p className="txt">② 예약 일자 및 시간 선택</p>
      <ul className="menual-list">
        <li>캘린더에서 시작일·종료일을 선택하세요.</li>
        <li>최대 2주(14일)까지 예약 가능합니다. (주말·공휴일 제외)</li>
        <li>예약 시간은 09:00 ~ 18:00 내에서 설정 가능합니다.</li>
      </ul>
      <p className="txt">③ 장비 선택</p>
      <ul className="menual-list">
        <li>선택한 일자·시간 기준으로 예약 가능한 장비 코드를 선택하세요.</li>
        <li>장비 상태값 : 사용중 / 수리중 / 운영종료</li>
      </ul>
      <p className="txt">④ 신청 버튼</p>
      <ul className="menual-list">
        <li>[장비 견적요청] : 사전 비용 확인이 필요한 경우 선택하세요.</li>
        <li>[장비 사용신청] : 즉시 신청하는 경우 선택하세요.</li>
      </ul>
    </div>
  );
}

function TspContent4_2_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 실증장비 예약 &gt; <MLink to="/tsp/Apply/Equipment">장비신청</MLink> &gt; 장비신청 상세 &gt; 장비 견적요청</p>
      <p className="txt">① 기본정보</p>
      <ul className="menual-list">
        <li>소속, 사업자등록번호, 이름, 연락처 : 자동 입력</li>
        <li>본사 주소 : 우편번호 검색 후 직접 입력하세요.</li>
        <li>할인 항목 : 3개 중 1개만 선택 가능 (중복 선택 불가)</li>
        <li>광주시 AI 유치기업 여부 (30% 할인)</li>
        <li>광주 소재 중소·벤처기업 여부 (30% 할인)</li>
        <li>인공지능산업융합집적단지 입주기업 (30% 할인)</li>
      </ul>
      <p className="txt">② 장비정보 / 이용내역</p>
      <ul className="menual-list">
        <li>장비명, 카테고리, 1일 가용시간, 이용기간, 총 사용시간, 사용 대수, 1시간 사용료, 예상 사용금액을 확인할 수 있습니다.</li>
        <li>예상 사용금액은 담당자 검토 후 변경될 수 있습니다.</li>
      </ul>
      <p className="txt">③ 서류 제출</p>
      <ul className="menual-list">
        <li>사업자등록증을 첨부하세요.</li>
      </ul>
      <p className="txt">④ 개인정보 수집 동의 후 [요청] 클릭 시 견적 요청이 완료됩니다.</p>
    </div>
  );
}

function TspContent4_2_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 마이페이지 &gt; AI 실증지원 &gt; <MLink to="/tsp/Mypage/Estimation">장비견적요청관리</MLink></p>
      <ul className="menual-list">
        <li>요청 내역 및 상태를 확인할 수 있습니다.</li>
        <li>처리 전 건에 한해 취소할 수 있습니다.</li>
      </ul>
      <p className="txt">① 견적서 확인</p>
      <ul className="menual-list">
        <li>담당자가 검토·발급한 견적서를 확인하세요.</li>
        <li>장비명, 이용기간, 총 사용시간, 사용 대수, 1시간 사용료, 최종 사용금액을 확인할 수 있습니다.</li>
        <li>할인 적용 내역이 있는 경우 함께 표시됩니다.</li>
      </ul>
    </div>
  );
}

function TspContent4_3_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 실증장비 예약 &gt; <MLink to="/tsp/Apply/Equipment">장비신청</MLink> &gt; 장비신청 상세 &gt; 장비 사용신청</p>
      <p className="txt">① 기본정보</p>
      <ul className="menual-list">
        <li>소속, 사업자등록번호, 이름, 연락처 : 자동 입력</li>
        <li>본사 주소 : 우편번호 검색 후 직접 입력하세요.</li>
        <li>할인 항목 : 3개 중 1개만 선택 가능 (중복 선택 불가)</li>
        <li>광주시 AI 유치기업 여부 (30% 할인)</li>
        <li>광주 소재 중소·벤처기업 여부 (30% 할인)</li>
        <li>인공지능산업융합집적단지 입주기업 (30% 할인)</li>
      </ul>
      <p className="txt">② 장비정보 / 이용내역</p>
      <ul className="menual-list">
        <li>장비명, 카테고리, 1일 가용시간, 이용기간, 총 사용시간, 사용 대수, 1시간 사용료, 예상 사용금액을 확인할 수 있습니다.</li>
        <li>예상 사용금액은 담당자 검토 후 변경될 수 있습니다.</li>
      </ul>
      <p className="txt">③ 활용 계획</p>
      <ul className="menual-list">
        <li>활용목적을 직접 입력하세요. (최대 1,000자)</li>
        <li>첨부파일 최대 5개 등록 가능</li>
      </ul>
      <p className="txt">④ 개인정보 수집 동의 후 [신청] 클릭 시 사용 신청이 완료됩니다.</p>
    </div>
  );
}

function TspContent4_3_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 마이페이지 &gt; AI 실증지원 &gt; <MLink to="/tsp/Mypage/Equipment">장비사용관리</MLink></p>
      <ul className="menual-list">
        <li>신청 내역 및 상태를 확인할 수 있습니다.</li>
        <li>상태 필터 : 전체 / 신청 / 신청취소 / 보완요청 / 승인 / 반려</li>
        <li>처리 전 건에 한해 취소할 수 있습니다.</li>
        <li>담당자 검토 후 승인 또는 반려 여부가 안내됩니다.</li>
        <li>반려된 경우 해당 내역에서 사유를 확인할 수 있습니다.</li>
        <li>보완요청이 있는 경우 요청 내용 확인 후 내역을 수정하여 재제출하세요.</li>
      </ul>
    </div>
  );
}

function TspContent4_3_3() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 실증장비 예약 &gt; <MLink to="/tsp/Apply/Notice">사용안내</MLink></p>
      <ul className="menual-list">
        <li>승인 완료 후 예약 일자·시간에 장비 설치 장소를 방문하여 장비를 사용하세요.</li>
        <li>문의가 필요한 경우 사용안내 페이지에서 분야별 담당자 정보를 확인하세요.</li>
      </ul>
    </div>
  );
}

function TspContent4_3_4() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 마이페이지 &gt; AI 실증지원 &gt; <MLink to="/tsp/Mypage/Equipment">장비사용관리</MLink></p>
      <ul className="menual-list">
        <li>예약 종료일 이후 장비를 원래 위치에 반납하세요.</li>
        <li>반납 완료 후 담당자가 사용 종료 처리를 진행합니다.</li>
        <li>반납 관련 문의는 분야별 담당자에게 연락하세요.</li>
      </ul>
    </div>
  );
}

function TspContent4_3_5() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 마이페이지 &gt; AI 실증지원 &gt; <MLink to="/tsp/Mypage/Equipment">장비사용관리</MLink></p>
      <ul className="menual-list">
        <li>① 장비 사용료 최종 산정</li>
        <li>② 고지내역서 발급</li>
        <li>③ 사용료 납부</li>
      </ul>
      <p className="txt">납부 내역 및 처리 현황은 장비사용관리에서 확인할 수 있습니다.</p>
    </div>
  );
}

/* ── 5. 대시보드 (TSP·USP 공통 본문, 대시보드 진입 경로만 포털별 상이) ── */

export function DashboardManualBody({ dashboardTo }: { dashboardTo: string }) {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        로그인 후 마이페이지의 첫 화면으로, 서비스별 신청 현황을 한눈에 확인할 수 있습니다.
      </p>
      <p className="txt">
        📌 마이페이지 &gt; <MLink to={dashboardTo}>대시보드</MLink>
      </p>
      <p className="txt">① 상단 영역</p>
      <ul className="menual-list">
        <li>로그인한 회원의 이름이 표시됩니다.</li>
        <li>[알림] 클릭 시 알림 팝업이 노출됩니다.</li>
        <li>[회원정보 변경] 클릭 시 회원정보변경 페이지로 이동합니다.</li>
      </ul>
      <p className="txt">② 탭 메뉴 (빠른 이동)</p>
      <ul className="menual-list">
        <li>기업정보 변경 / 입주기업 성과조사 / 1:1문의내역 탭을 확인할 수 있습니다.</li>
        <li>[기업정보 변경] 클릭 시 대시보드 &gt; AI 기업지원 &gt; 기업정보 등록 페이지로 이동합니다.</li>
        <li>[입주기업 성과조사] 클릭 시 성과조사를 모루 페이지로 이동합니다.</li>
        <li>[1:1문의내역] 클릭 시 1:1문의내역 목록 페이지로 이동합니다.</li>
      </ul>
      <p className="txt">③ 시설예약관리</p>
      <ul className="menual-list">
        <li>시설 예약 내역을 최근 순으로 최대 3개 노출합니다.</li>
        <li>상태값 : 신청 / 보완요청 / 반려 / 신청취소 / 사용중 / 사용종료 / 입금대기 / 입금완료</li>
        <li>[상세보기] 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>[시설예약관리 &gt;] 클릭 시 해당 마이페이지로 이동합니다.</li>
        <li>신청 건이 없을 경우 '시설 예약 건이 없습니다.' 안내 메시지가 노출됩니다.</li>
        <li>[시설 예약하러가기] 클릭 시 시설 이용신청 페이지로 이동합니다.</li>
      </ul>
      <p className="txt">④ 전문가 자문 신청</p>
      <ul className="menual-list">
        <li>전문가 자문 신청 내역을 최근 순으로 최대 2개 노출합니다.</li>
        <li>상태값 : 신청 / 보완요청 / 신청취소 / 승인 / 자문완료</li>
        <li>[상세보기] 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>[전문가 자문 신청 &gt;] 클릭 시 해당 마이페이지로 이동합니다.</li>
        <li>신청 건이 없을 경우 '전문가 자문 신청 건이 없습니다.' 안내 메시지가 노출됩니다.</li>
        <li>[자문 신청하러가기] 클릭 시 전문가 자문 신청 페이지로 이동합니다.</li>
      </ul>
      <p className="txt">⑤ 코디네이팅 신청</p>
      <ul className="menual-list">
        <li>코디네이팅 신청 내역을 최근 순으로 최대 2개 노출합니다.</li>
        <li>상태값 : 신청 / 보완요청 / 신청취소 / 승인 / 상담완료</li>
        <li>[상세보기] 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>[코디네이팅 신청 &gt;] 클릭 시 해당 마이페이지로 이동합니다.</li>
        <li>신청 건이 없을 경우 '코디네이팅 신청 건이 없습니다.' 안내 메시지가 노출됩니다.</li>
        <li>[코디네이팅 신청하러가기] 클릭 시 코디네이팅 신청 페이지로 이동합니다.</li>
      </ul>
      <p className="txt">⑥ 사업관리시스템</p>
      <ul className="menual-list">
        <li>사업신청 / 발표자료 / 사업계획서 / 전자협약 / 협약변경 / 보고서 제출 / 성과관리 탭별 처리 중 또는 처리 요청 받은 업무 건수를 확인할 수 있습니다.</li>
        <li>사업관리 전체 메뉴의 임시저장 / 제출요청 / 보완요청 / 서명요청 건이 표시됩니다.</li>
        <li>각 탭 클릭 시 해당 탭 목록으로 변경됩니다. (최대 2건 노출)</li>
        <li>[상세보기] 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>[사업관리시스템 &gt;] 클릭 시 해당 마이페이지로 이동합니다.</li>
        <li>건이 없을 경우 탭별 안내 메시지가 노출됩니다.</li>
        <li>사업신청 : '진행 중인 사업 신청 내역이 없습니다.' / [사업 신청하기] 클릭 시 모집공고 목록 페이지로 이동합니다.</li>
        <li>발표자료 / 사업계획서 / 전자협약 / 보고서 제출 / 성과관리 : 해당 안내 메시지 노출, 버튼 없음</li>
      </ul>
      <p className="txt">⑦ 장비 견적요청</p>
      <ul className="menual-list">
        <li>장비 견적요청 내역을 최근 순으로 최대 2개 노출합니다.</li>
        <li>상태값 : 신청 / 보완요청 / 견적서발급 / 신청취소</li>
        <li>[상세보기] 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>[장비 견적요청 &gt;] 클릭 시 해당 마이페이지로 이동합니다.</li>
        <li>신청 건이 없을 경우 '장비 견적요청 건이 없습니다.' 안내 메시지가 노출됩니다.</li>
        <li>[장비 견적 요청하러가기] 클릭 시 장비 신청 목록화면으로 이동합니다.</li>
      </ul>
      <p className="txt">⑧ 장비 사용신청</p>
      <ul className="menual-list">
        <li>장비 사용신청 내역을 최근 순으로 최대 2개 노출합니다.</li>
        <li>상태값 : 신청 / 보완요청 / (장기)보완요청 / 반려 / 신청취소 / 사용중 / 사용종료</li>
        <li>사용 중인 건에 D-day가 표시됩니다.</li>
        <li>[상세보기] 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>[장비 사용신청 &gt;] 클릭 시 해당 마이페이지로 이동합니다.</li>
        <li>신청 건이 없을 경우 '장비 사용신청 건이 없습니다.' 안내 메시지가 노출됩니다.</li>
        <li>[장비 사용신청하러가기] 클릭 시 장비 신청 목록화면으로 이동합니다.</li>
      </ul>
      <p className="txt">⑨ 데이터신청현황</p>
      <ul className="menual-list">
        <li>데이터 활용 신청 내역을 최근 순으로 최대 3개 노출합니다.</li>
        <li>상태값 : 승인검토중 / 승인완료 / 반려</li>
        <li>[상세보기] 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>[데이터신청현황 &gt;] 클릭 시 해당 마이페이지로 이동합니다.</li>
        <li>신청 건이 없을 경우 '데이터 신청 건이 없습니다.' 안내 메시지가 노출됩니다.</li>
        <li>[데이터 신청하러가기] 클릭 시 데이터 신청 목록화면으로 이동합니다.</li>
      </ul>
      <p className="txt">⑩ 안심구역 신청현황</p>
      <ul className="menual-list">
        <li>안심구역 신청 현황을 최근 순으로 최대 3개 노출합니다.</li>
        <li>상태값 : 승인검토중 / 승인완료 / 이용중 / 종료 / 반려</li>
        <li>[상세보기] 클릭 시 해당 안심구역 관리 상세 페이지로 이동합니다.</li>
        <li>승인검토중, 반려 상태인 경우 [상세보기]가 노출되지 않습니다.</li>
        <li>[안심구역 신청현황 &gt;] 클릭 시 해당 마이페이지로 이동합니다.</li>
        <li>신청 건이 없을 경우 '안심구역 신청 건이 없습니다.' 안내 메시지가 노출됩니다.</li>
      </ul>
    </div>
  );
}

export function TspContent5() {
  return <DashboardManualBody dashboardTo="/tsp/Mypage/Dashboard" />;
}

/* ── 6. AI 실증지원 소개 ── */

function TspContent6() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        자동차, 에너지, 헬스케어 분야의 실증센터 소개, 분야별 실증장비 안내, 오시는 길을 확인할 수 있습니다.
      </p>
      <p className="txt">① <MLink to="/tsp/Info/Equipment">실증센터</MLink></p>
      <ul className="menual-list">
        <li>추진목표, 추진내용 등 실증지원센터의 전반적인 소개 정보를 확인할 수 있습니다.</li>
        <li>자동차 / 에너지 / 헬스케어 분야별 실증 서비스 소개를 확인할 수 있습니다.</li>
      </ul>
      <p className="txt">② <MLink to="/tsp/Info/Equipment/Car">자동차 실증장비</MLink></p>
      <ul className="menual-list">
        <li>AI 기반 차량 시뮬레이션, 차량용 통신 + 커넥티드카, 차량 데이터 수집, 평가 및 인증자원 체계 구축 등 자동차 분야 실증 서비스 내용을 확인할 수 있습니다.</li>
      </ul>
      <p className="txt">③ <MLink to="/tsp/Info/Equipment/Energy">에너지 실증장비</MLink></p>
      <ul className="menual-list">
        <li>에너지 고장진단, 에너지 탐지 및 분석, 에너지 거래분석, AI 빅데이터 활용 상용화 실증 플랫폼 등 에너지 분야 실증 서비스 내용을 확인할 수 있습니다.</li>
      </ul>
      <p className="txt">④ <MLink to="/tsp/Info/Equipment/HealthCare">헬스케어 실증장비</MLink></p>
      <ul className="menual-list">
        <li>AI 보건소, 병·의원, AI 시민체감, 공통 등 헬스케어 분야 실증 서비스 내용을 확인할 수 있습니다.</li>
      </ul>
      <p className="txt">⑤ <MLink to="/tsp/About/Map">오시는 길</MLink></p>
      <ul className="menual-list">
        <li>탭 메뉴 : AI 자동차·에너지 실증센터 / AI 헬스케어 실증센터</li>
        <li>탭 클릭 시 해당 센터의 지도 및 주소 정보로 변경됩니다.</li>
        <li>AI 자동차·에너지 실증센터 : 광주광역시 북구 오룡동 1013 / 062-610-3900</li>
        <li>AI 헬스케어 실증센터 : 광주광역시 남구 노대동 592 / 062-602-7275</li>
        <li>[네이버지도] / [카카오맵] 클릭 시 해당 주소로 지도 페이지가 새창으로 열립니다.</li>
        <li>분야별 담당자 정보는 <MLink to="/tsp/Apply/Notice">사용안내</MLink> 페이지에서 확인하세요.</li>
      </ul>
    </div>
  );
}

/* ── 7. 이용지원 ── */

function TspContent7() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        공지사항과 자주묻는질문(FAQ)을 통해 서비스 이용 관련 정보를 확인할 수 있습니다.
      </p>
    </div>
  );
}

function TspContent7_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 이용지원 &gt; <MLink to="/tsp/About/Notice">공지사항</MLink></p>
      <ul className="menual-list">
        <li>검색 : 제목 기준 검색 가능</li>
        <li>목록은 최대 10개씩 노출됩니다.</li>
        <li>게시글 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>상세 페이지에서 제목, 등록일, 첨부파일, 본문 내용을 확인할 수 있습니다.</li>
        <li>첨부파일명 클릭 시 해당 파일이 다운로드됩니다.</li>
        <li>[이전 글] / [다음 글] 클릭 시 해당 게시글로 이동합니다.</li>
        <li>[목록] 클릭 시 공지사항 목록으로 이동합니다.</li>
      </ul>
    </div>
  );
}

function TspContent7_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 이용지원 &gt; <MLink to="/tsp/About/FAQ">자주묻는질문</MLink></p>
      <ul className="menual-list">
        <li>탭 메뉴 : 장비이용/예약 / 비용/결제 / 장비/기술지원</li>
        <li>탭 클릭 시 해당 카테고리 질문 목록으로 변경됩니다.</li>
        <li>질문 항목 클릭 시 답변이 펼쳐지는 아코디언 방식으로 표시됩니다.</li>
      </ul>
    </div>
  );
}

/* ── 8. 1:1 문의 ── */

export function TspContent8() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        문의 등록 및 답변 확인을 통해 서비스 이용 중 궁금한 사항을 문의할 수 있습니다.
      </p>
    </div>
  );
}

function TspContent8_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 이용지원 &gt; <MLink to="/tsp/About/Inquiry">1:1문의</MLink> &gt; [문의 등록]</p>
      <ul className="menual-list">
        <li>구분을 선택하세요. : 전체 / AI 기업지원 / 사업관리시스템 / AI 실증지원 / AI 데이터지원</li>
        <li>제목을 입력하세요.</li>
        <li>문의 내용을 입력하세요.</li>
        <li>첨부파일을 등록하세요.</li>
        <li>공개 설정 : 공개글 / 비밀글 선택 (기본값 : 비밀글)</li>
        <li>[완료] 클릭 시 문의가 등록됩니다.</li>
        <li>[취소] 클릭 시 이전 페이지로 이동합니다.</li>
      </ul>
    </div>
  );
}

function TspContent8_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">📌 마이페이지 &gt; <MLink to="/tsp/Mypage/Inquiry">1:1문의내역</MLink></p>
      <ul className="menual-list">
        <li>구분 필터 : 전체 / AI 기업지원 / 사업관리시스템 / AI 실증지원 / AI 데이터지원</li>
        <li>검색 : 제목 기준 검색 가능</li>
        <li>작성자는 가운데 자리 마스킹(*) 처리되어 노출됩니다.</li>
        <li>목록은 최대 10개씩 노출됩니다.</li>
        <li>게시글 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>상세 페이지에서 제목, 구분, 작성자, 등록일, 내용, 첨부파일을 확인할 수 있습니다.</li>
        <li>담당자 답변이 등록된 경우 답변 내용을 확인할 수 있습니다.</li>
        <li>[이전 글] / [다음 글] 클릭 시 해당 게시글로 이동합니다.</li>
      </ul>
    </div>
  );
}

const PLACEHOLDER = (
  <div className="menual-panel-body-inner">
    <p className="txt">준비 중입니다.</p>
  </div>
);

export function renderTspContent(key: string): React.ReactNode {
  switch (key) {
    case 'tsp-1': return <TspContent1 />;
    case 'tsp-2': return <TspContent2 />;
    case 'tsp-2-1': return <TspContent2_1 />;
    case 'tsp-2-2': return <TspContent2_2 />;
    case 'tsp-2-3': return <TspContent2_3 />;
    case 'tsp-2-4': return <TspContent2_4 />;
    case 'tsp-3': return <TspContent3 />;
    case 'tsp-3-1': return <TspContent3_1 />;
    case 'tsp-3-2': return <TspContent3_2 />;
    case 'tsp-3-3': return <TspContent3_3 />;
    case 'tsp-3-4': return <TspContent3_4 />;
    case 'tsp-4': return <TspContent4 />;
    case 'tsp-4-1': return null;
    case 'tsp-4-1-1': return <TspContent4_1_1 />;
    case 'tsp-4-1-2': return <TspContent4_1_2 />;
    case 'tsp-4-2': return null;
    case 'tsp-4-2-1': return <TspContent4_2_1 />;
    case 'tsp-4-2-2': return <TspContent4_2_2 />;
    case 'tsp-4-3': return null;
    case 'tsp-4-3-1': return <TspContent4_3_1 />;
    case 'tsp-4-3-2': return <TspContent4_3_2 />;
    case 'tsp-4-3-3': return <TspContent4_3_3 />;
    case 'tsp-4-3-4': return <TspContent4_3_4 />;
    case 'tsp-4-3-5': return <TspContent4_3_5 />;
    case 'tsp-5': return <TspContent5 />;
    case 'tsp-6': return <TspContent6 />;
    case 'tsp-7': return <TspContent7 />;
    case 'tsp-7-1': return <TspContent7_1 />;
    case 'tsp-7-2': return <TspContent7_2 />;
    case 'tsp-8': return <TspContent8 />;
    case 'tsp-8-1': return <TspContent8_1 />;
    case 'tsp-8-2': return <TspContent8_2 />;
    default: return PLACEHOLDER;
  }
}
